export default __webpack_public_path__ + "static/4_overlay-20c0a4307f851c18e7b3d438ea351236.png";